import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, COMMON, API_CONSTANTS } from '../../global/Constants';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { ActivityType, HeaderTypes } from "../../global/Enum";
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import SyncLoader from '../common/loader/SyncLoader';

class Calendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            activityEvents: [],
            isCurrentMonth: true,
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            events: [
                // { title: "Pending", date: '2021-01-04', type: 0, display: 'background' },
                // { title: ActivityType.INDIVIDUAL_VISIT, date: '2021-07-04', type: 0 },
                // { title: ActivityType.SAMPLE_DISTRIBUTION, date: '2021-07-04', className: 'fc-opacity-true' },
                // { title: ActivityType.GROUP_MEET, date: '2021-01-04', type: 1 },
                // { title: ActivityType.SAMPLE_TO_SALE, date: '2021-03-04' },
            ]
        }
    }

    componentDidMount() {

        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            const { month, year } = this.state;
            this.getMonthEvents(month, year);
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }

    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    async getMonthEvents(month, year) {

        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });
            var request = JSON.stringify({
                monthYear: `${year}-${('0' + month).slice(-2)}`
            });

            Utilities.LogPrint("Request", request);
            try {
                ApiServices.getCalendarActivityByMonth(request)
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        //this.setState({ isLoading: false });
                        if (response.success) {
                            const data = response.data;
                            if (data != null) {
                                this.setEvents(data);
                            }
                        } else {
                            Utilities.LogPrint("Status", response.message);
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        }
    }

    setEvents(data) {
        let events = [];
        data?.activity.forEach(element => {
            if (element.IV === 1) {
                events.push({ title: ActivityType.INDIVIDUAL_VISIT, date: element.full_date })
            } else {
                events.push({ title: ActivityType.INDIVIDUAL_VISIT, date: element.full_date, className: 'fc-opacity-true' })
            }

            if (element.SD === 1) {
                events.push({ title: ActivityType.SAMPLE_DISTRIBUTION, date: element.full_date })
            } else {
                events.push({ title: ActivityType.SAMPLE_DISTRIBUTION, date: element.full_date, className: 'fc-opacity-true' })
            }

            if (element.GM === 1) {
                events.push({ title: ActivityType.GROUP_MEETING, date: element.full_date })
            } else {
                events.push({ title: ActivityType.GROUP_MEETING, date: element.full_date, className: 'fc-opacity-true' })
            }

            if (element.STS === 1) {
                events.push({ title: ActivityType.SAMPLE_TO_SALE, date: element.full_date })
            } else {
                events.push({ title: ActivityType.SAMPLE_TO_SALE, date: element.full_date, className: 'fc-opacity-true' })
            }

            if (element.IS_PENDING === 1) {
                events.push({ title: "Pending", date: element.full_date, display: 'background' })
            }
        });

        // data?.holiday.forEach(element => {
        //     events.push({ title: element.title, date: element.full_date, className: 'holiday-text' })
        // });

        Utilities.LogPrint("Events--", events);

        this.setState({
            events: events,
            activityEvents: data?.activity,
            isLoading: false
        });

        //return events;
    }


    handleDateClick = (arg) => { // bind with an arrow function
        //this.props.history.push(ALL_ROUTES.CALENDAR_DAY_ROUTE);

        if (this.checkActivity(arg.dateStr)) {
            this.props.history.push({
                pathname: ALL_ROUTES.CALENDAR_DAY_ROUTE,
                state: { date: arg.dateStr }
            });
        } else {
            alert("No Activity Found");
        }
    }

    checkActivity(date) {
        const { activityEvents } = this.state;
        return activityEvents.some(item => item.full_date === date);
    }


    async getEvents() {
        return this.state.events;
    }


    handleMonthChange = (month, year) => {
        Utilities.LogPrint("MONTH---->", month + " " + year);

        this.getMonthEvents(month, year);
        this.setState({ month: month, year: year })
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header selectedTab={HeaderTypes.CALENDAR} handleSyncLoading={this.handleSyncLoading} />
                <Footer isActive={1} />

                <div className="container pt-35 pb-65">
                    <div className="full-calender-custom">
                        <FullCalendar
                            plugins={[dayGridPlugin, interactionPlugin]}
                            initialView="dayGridMonth"
                            weekends={true}
                            dateClick={this.handleDateClick}
                            //events={this.state.events}
                            //eventContent={renderEventContent}
                            events={(fetchInfo) => {
                                if (fetchInfo) {
                                    let year = new Date(fetchInfo.end).getFullYear();
                                    let month = new Date(fetchInfo.end).getMonth();
                                    if (month === 0) {
                                        month = 12;
                                        year = new Date(fetchInfo.end).getFullYear() - 1;
                                    }
                                    if (this.state.month !== month) {
                                        //this.getMonthEvents(month, year);
                                        this.handleMonthChange(month, year);
                                    }
                                }
                                return this.getEvents();
                            }}
                        />
                    </div>
                </div>
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
            </div>
        );
    }

}


export default withRouter(Calendar);